import axios from 'axios';

import { ROOT_URL_V2, getCSRFToken } from '../config';
import { updateLoading } from './Loading';
import actions from '../actions';

export type TmassBookingPayload = {
    freelancers: number[];
    jobrequests?: number[];
    series?: number;
};

export const createMassBookingAsync =
    (
        massBookingPayload: TmassBookingPayload,
        isInvite = false,
        axiosAbortController: any,
    ) =>
    async(dispatch: any) => {
        let massBookingResults;

        dispatch(updateLoading('massBooking', true));

        try {
            const response = await axios({
                method: 'POST',
                url: `${ROOT_URL_V2}jobs/${
                    isInvite ? 'mass_invitation' : 'mass_booking'
                }/`,
                data: massBookingPayload,
                headers: {
                    'X-CSRFToken': getCSRFToken(),
                },
                signal: axiosAbortController.signal,
            });
            massBookingResults = response.data.content;
        } catch (error) {
            dispatch(actions.createMassBookingFailure(error));
            dispatch(updateLoading('massBooking', false));
            return;
        }

        dispatch(actions.createMassBookingSuccess(massBookingResults));
        dispatch(updateLoading('massBooking', false));
    };
